import { client } from 'src/services/datadog/client';
import type { FetchierConfig } from '../types';
import { FetchRequestBlockedError } from './FetchRequestBlockedError';

export async function fetchWithTimeout(
    url: RequestInfo | URL,
    opts?: FetchierConfig,
    timeout?: number
): Promise<Response> {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    try {
        const init = {
            ...opts,
            signal: controller.signal,
        } as RequestInit;
        const response = await globalThis.fetch(url, init);
        clearTimeout(id);
        return response;
    } catch (err: unknown) {
        if ((err as Error).name === 'AbortError') {
            throw new Error(`Fetch request timeout: ${url}`);
        }
        if ((err as Error).message === 'Load failed') {
            const error = new FetchRequestBlockedError((err as Error).message);
            await client.addError(error, {
                url,
                opts,
                timeout,
            });
            throw error;
        }
        throw err;
    }
}
